import BaseControllerClass from './BaseController';
import ControllerClass from './Controller';
import UniversalControllerClass from './UniversalController';
import ModuleClass from './Module';
// Needed to test for instanceof.
export { default as ModuleClass } from './Module';

export function BaseController(rootModule, options) {
  return new BaseControllerClass(rootModule, options);
}

export function Controller(rootModule, options) {
  return new ControllerClass(rootModule, options);
}

export function UniversalController(rootModule, options) {
  return new UniversalControllerClass(rootModule, options);
}

export function Module(definition) {
  return new ModuleClass(definition);
}

export { default as CerebralError } from './CerebralError';
export { default as Provider } from './Provider';
export { default as Compute } from './Compute';
export { sequence, parallel } from 'function-tree';

export { default as View } from './View';
export { createDummyController, throwError } from './utils';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/es/index.js
// module id = 4
// module chunks = 0